import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

//components
import Head from 'components/common/Head/Head';
//styles
import { ErrorContainer, Header, Message, IconWrapper } from '../ErrorPages.styled';
import { DefaultButton } from 'components/styled/Button';
//assets
import errorIllustration from 'assets/illustrations/403.png';
import { ArrowRightIcon } from 'assets/icons';

export const ForbiddenErrorScreen = () => {
  const { t } = useTranslation();

  return (
    <ErrorContainer>
      <Head title={t('Access denied')} />
      <img
        src={errorIllustration}
        alt="403 Error"
        width={500}
        height={296}
        style={{ marginBottom: '2rem' }}
      />

      <Header>{t('Access denied')}</Header>
      <Message>{t('You do not have permission to access this page')}</Message>
      <Link to={'/accommodations/dashboard'}>
        <DefaultButton type="button" color="blue">
          <IconWrapper>
            <ArrowRightIcon rotate={180} stroke="white" />
          </IconWrapper>
          {t('Back to homepage')}
        </DefaultButton>
      </Link>
    </ErrorContainer>
  );
};
